// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-user-creation-form-divider {
  height: 15.9em;
  background-color: whitesmoke;
}

.modal-spaces-layout > .ant-space-item {
  margin-right: 1% !important;
}

.modal-spaces-layout > span.ant-space-item-split {
  margin-right: 2% !important;
}

.table-user-tabpane-expendable {
  padding: 2%;
  padding-top: 2%;
  padding-left: 0%;
}

.roles-tab-pane-scrollable-div {
  overflow-y: "auto" !important;
  height: 500 !important;
  width: 100% !important;
}

.roles-tab-pane-scrollable-div::-webkit-scrollbar {
  display: none;
}

.roles-transfer-component .ant-transfer-list {
  width: 100% !important;
}

.no-step-modal-body-div-layout {
  padding-left: 4%;
  padding-right: 4%;
}

.user-status-switch {
  /* width: 100% !important; */
}

.user-status-switch span.ant-switch-inner {
  color: #258ffb !important;
}

.user-status-switch .ant-switch-handle:before {
  background: #258ffb;
}

button.user-status-switch {
  background: none;
  border: 1px solid #258ffb;
  line-height: 23px !important;
  height: 23px !important;
}

.ant-switch.user-status-switch.ant-switch-checked {
  background: #258ffb;
}
.user-status-switch.ant-switch-checked span.ant-switch-inner {
  color: #ffffff !important;
}
.user-status-switch.ant-switch-checked .ant-switch-handle:before {
  background: #ffffff;
}

.ant-picker-panel-container .ant-picker-panels {
  display: inline-flex !important;
  flex-wrap: wrap !important;
  direction: ltr !important;
  width: 279px !important;
}

/** Mobile transfer list style **/

@media screen and (max-width: 900px) {
  .ant-transfer-list {
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;
    height: 200px !important;
    border: 1px solid #d9d9d9 !important;
    border-radius: 2px !important;
  }

  .ant-transfer {
    box-sizing: border-box !important;
    margin: 0 !important;
    padding: 0 !important;
    color: rgba(0, 0, 0, 0.85) !important;
    font-size: 14px !important;
    font-variant: tabular-nums !important;
    line-height: 1.5715 !important;
    list-style: none !important;
    font-feature-settings: "tnum", "tnum" !important;
    position: relative !important;
    align-items: stretch !important;
    display: list-item !important;
  }

  .ant-transfer-operation {
    display: flex !important;
    flex: none !important;
    flex-direction: column !important;
    align-self: center !important;
    margin: 4% !important;
    vertical-align: middle !important;
  }

  button.ant-btn.ant-btn-primary.ant-btn-sm.ant-btn-icon-only {
    width: 100% !important;
  }
}

@media screen and (min-width: 901px) {
  .ant-transfer-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 200px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
  }
}

@media screen and (max-width: 800px) {
  .user-creation-child-div {
    overflow: scroll;
    overflow-y: 700;
  }
}
`, "",{"version":3,"sources":["webpack://./src/dist/style/user_component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,iCAAiC;;AAEjC;EACE;IACE,wBAAwB;IACxB,iCAAiC;IACjC,sBAAsB;IACtB,wBAAwB;IACxB,oCAAoC;IACpC,6BAA6B;EAC/B;;EAEA;IACE,iCAAiC;IACjC,oBAAoB;IACpB,qBAAqB;IACrB,qCAAqC;IACrC,0BAA0B;IAC1B,qCAAqC;IACrC,8BAA8B;IAC9B,2BAA2B;IAC3B,gDAAgD;IAChD,6BAA6B;IAC7B,+BAA+B;IAC/B,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;IACrB,iCAAiC;IACjC,6BAA6B;IAC7B,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".modal-user-creation-form-divider {\n  height: 15.9em;\n  background-color: whitesmoke;\n}\n\n.modal-spaces-layout > .ant-space-item {\n  margin-right: 1% !important;\n}\n\n.modal-spaces-layout > span.ant-space-item-split {\n  margin-right: 2% !important;\n}\n\n.table-user-tabpane-expendable {\n  padding: 2%;\n  padding-top: 2%;\n  padding-left: 0%;\n}\n\n.roles-tab-pane-scrollable-div {\n  overflow-y: \"auto\" !important;\n  height: 500 !important;\n  width: 100% !important;\n}\n\n.roles-tab-pane-scrollable-div::-webkit-scrollbar {\n  display: none;\n}\n\n.roles-transfer-component .ant-transfer-list {\n  width: 100% !important;\n}\n\n.no-step-modal-body-div-layout {\n  padding-left: 4%;\n  padding-right: 4%;\n}\n\n.user-status-switch {\n  /* width: 100% !important; */\n}\n\n.user-status-switch span.ant-switch-inner {\n  color: #258ffb !important;\n}\n\n.user-status-switch .ant-switch-handle:before {\n  background: #258ffb;\n}\n\nbutton.user-status-switch {\n  background: none;\n  border: 1px solid #258ffb;\n  line-height: 23px !important;\n  height: 23px !important;\n}\n\n.ant-switch.user-status-switch.ant-switch-checked {\n  background: #258ffb;\n}\n.user-status-switch.ant-switch-checked span.ant-switch-inner {\n  color: #ffffff !important;\n}\n.user-status-switch.ant-switch-checked .ant-switch-handle:before {\n  background: #ffffff;\n}\n\n.ant-picker-panel-container .ant-picker-panels {\n  display: inline-flex !important;\n  flex-wrap: wrap !important;\n  direction: ltr !important;\n  width: 279px !important;\n}\n\n/** Mobile transfer list style **/\n\n@media screen and (max-width: 900px) {\n  .ant-transfer-list {\n    display: flex !important;\n    flex-direction: column !important;\n    width: 100% !important;\n    height: 200px !important;\n    border: 1px solid #d9d9d9 !important;\n    border-radius: 2px !important;\n  }\n\n  .ant-transfer {\n    box-sizing: border-box !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    color: rgba(0, 0, 0, 0.85) !important;\n    font-size: 14px !important;\n    font-variant: tabular-nums !important;\n    line-height: 1.5715 !important;\n    list-style: none !important;\n    font-feature-settings: \"tnum\", \"tnum\" !important;\n    position: relative !important;\n    align-items: stretch !important;\n    display: list-item !important;\n  }\n\n  .ant-transfer-operation {\n    display: flex !important;\n    flex: none !important;\n    flex-direction: column !important;\n    align-self: center !important;\n    margin: 4% !important;\n    vertical-align: middle !important;\n  }\n\n  button.ant-btn.ant-btn-primary.ant-btn-sm.ant-btn-icon-only {\n    width: 100% !important;\n  }\n}\n\n@media screen and (min-width: 901px) {\n  .ant-transfer-list {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 200px;\n    border: 1px solid #d9d9d9;\n    border-radius: 2px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .user-creation-child-div {\n    overflow: scroll;\n    overflow-y: 700;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
